export const TypeSortMission = {
  CURRENT_MISSION: 'CURRENT_MISSION',
  FUTURE_MISSION: 'FUTURE_MISSION',
  PAST_MISSION: 'PAST_MISSION'
}
